export default __webpack_public_path__ + "static/media/mpn-picturemark-l.0e45138a.svg";